// ModalContext.js
import React, { createContext, useState, useContext } from 'react';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState(null);

  const handleFirstModalOpen = () => setActiveModal('first');
  const handleFirstModalClose = () => setActiveModal(null);

  const handleSecondModalOpen = () => setActiveModal('second');
  const handleSecondModalClose = () => setActiveModal(null);

  const handleThirdModalOpen = () => setActiveModal('third');
  const handleThirdModalClose = () => setActiveModal(null);

  return (
    <ModalContext.Provider value={{
      activeModal,
      handleFirstModalOpen, handleFirstModalClose,
      handleSecondModalOpen, handleSecondModalClose,
      handleThirdModalOpen, handleThirdModalClose
    }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
